<template>

  <li class="item_menu">

    <router-link tag="li" :to="{name:itemMenu.name}">

      <a href="#" :class="{'mm-active':isItemMenuActive}" @click="checkLink(itemMenu.name)">
        {{ itemMenu.menuTitle }}
      </a>

    </router-link>

  </li>

</template>
<script>
export default {
  name: 't-menu-group-item',
  props: {
    itemMenu: {
      type: Object,
      required: true
    }
  },
  methods: {

    checkLink(name) {

      if(this.$store.getters.getOpenMenuMobile){
        this.$store.commit("setOpenMenuMobile", false)
      }

      if (name === this.$route.name) {
        this.$emit("pageRefresh")
      }

    }

  },
  computed: {
    isItemMenuActive() {
      return this.itemMenu.pageId === this.$store.getters.getItemMenuActiveId;
    },
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>